// Guest gate — a signed-out visitor (shared post, public profile/church, Reels) taps a
// members-only action → ONE shared « Connecte-toi pour continuer » prompt (LoginPrompt)
// instead of scattered toasts. The current URL is stashed so DeepLinkHandler brings the
// visitor back to it right after signing in / registering.
const STASH_KEY = "yalola.pendingDeepLink";
export const LOGIN_REQUIRED_EVENT = "yalola:login_required";

export const stashReturnTo = (path) => {
  const dest = path || (window.location.pathname + window.location.search);
  if (!dest || dest === "/" || dest.startsWith("/?") || dest.startsWith("/home")) return;
  try {
    window.__yalolaPendingDeepLink = dest;
    sessionStorage.setItem(STASH_KEY, dest);
  } catch { /* noop */ }
};

export const pendingReturnTo = () => {
  try { return window.__yalolaPendingDeepLink || sessionStorage.getItem(STASH_KEY) || ""; } catch { return ""; }
};

// Onboarding opens on the requested tab (login | register).
export const authPath = (tab = "login") => `/?tab=${tab}`;

// reason: react | comment | save | follow | donate | attend | generic
export const requireLogin = (reason = "generic") => {
  try { window.dispatchEvent(new CustomEvent(LOGIN_REQUIRED_EVENT, { detail: { reason } })); } catch { /* noop */ }
};
